module.exports = __webpack_public_path__ + "img/13.8dced3f4.jpg";